import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NgxNotificationsService } from 'ngx-notify';
import { STORAGE_KEYS } from '../modules/shared/constants';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

    constructor(
        private router: Router,
        private ngxNotificationMessage: NgxNotificationsService,
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.headers.get('x-jdro-skip-errors') === 'true') {
            return next.handle(request);
        } else {
            return next.handle(request).pipe(
                tap({
                    error: (err) => {
                        if (err.status === 401 || err.status === 403) {
                            if (!this.router.url.includes('/multiversity/login')) {
                                for (const key of Object.values(STORAGE_KEYS.local)) { localStorage.removeItem(key); }
                                for (const key of Object.values(STORAGE_KEYS.session)) { sessionStorage.removeItem(key); }
                                this.router.navigate(['/multiversity/login'], { replaceUrl: true });
                            }
                        }
                    }
                }));
        }
    }
}
